function GetHourMinutes(time: any) {
  let hours = 0;
  let minutes = 0;
  if (time?.split(":")[0] == 12 && time?.split(" ")[1] == "AM") {
    hours = 0;
    minutes = Number(time?.split(":")[1]?.split(" ")[0]);
  } else if (time?.split(" ")[1] == "PM" && time?.split(":")[0] != "12") {
    hours = Number(time?.split(":")[0]) + 12;
    minutes = Number(time?.split(":")[1]?.split(" ")[0]);
  } else {
    hours = Number(time?.split(":")[0]);
    minutes = Number(time?.split(":")[1]?.split(" ")[0]);
  }
  return { minutes, hours };
}
export default GetHourMinutes;
